import aesjs from 'aes-js';

const decryptBytes = (bytes: any) => {
  const key = [14, 21, 34, 46, 51, 26, 57, 18, 39, 18, 14, 42, 33, 24, 45, 56];
  const encryptedBytes = aesjs.utils.hex.toBytes(bytes);
  // eslint-disable-next-line new-cap
  const aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(5));
  const decryptedBytes = aesCtr.decrypt(encryptedBytes);

  return aesjs.utils.utf8.fromBytes(decryptedBytes);
};

export default decryptBytes;
